// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/5d19482f0bb6d853fb5c.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"610a7577e991342e2890","122":"e3b8c3b114c18d5b2331","123":"802d83b52d6616135a7f"}[chunkId] + ".chunk.js";
};